import styled from "styled-components";
import theme from "../../../../Themes/light";
import { ThemeType } from "../../../../types/Theme";

const ProdutosPromocaoContainer = styled.div<{ theme: ThemeType }>`
  width: 100%;
  max-width: 100%;
  padding: 5rem 0 30rem 0;
  overflow: hidden;
  min-height: 35rem;

  .descricao {
    color: ${theme.colors.tertiary};
    padding-bottom: 2rem;
    text-align: left;
    font-size: 12px;
  }

  .button-filtrar {
    padding: 0.5rem;
  }

  .grid-header {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 100%;
    column-gap: 2rem;
    row-gap: 1rem;
    padding-bottom: 2rem;

    .full-width {
      width: 100%;
      max-width: 100%;
      flex-grow: 1;
    }

    .half-width {
      width: calc(50% - 1rem);
      min-width: 15rem;
      flex-grow: 1;
    }

    @media (max-width: 680px) {
      .half-width {
        width: 100%;
        min-width: unset;
      }
    }
  }

  .produtos-wrapper {
    width: 100%;
    max-width: 100%;
    display: grid;
    padding: 0;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    height: 80vh;
    min-height: 200rem;
    overflow: hidden;
    transition: 0.3s ease-in-out;

    .informacoes {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 100%;
      padding: 1rem 0;

      &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 2px;
        border-radius: 50px;
        background-color: ${theme.colors.elements};
        top: 0;
        left: 0;
      }

      .flex-container-produtos {
        width: 100%;
        max-width: 100%;
        flex-wrap: wrap;
        padding: 1rem 0;
        column-gap: 2rem;
        row-gap: 1rem;
        display: flex;
        justify-content: space-between;
        white-space: nowrap;
        color: ${theme.colors.tertiary};

        .container-half {
          width: calc(50% - 1rem);
          min-width: 15rem;
          flex-grow: 1;
          .botao {
            padding: 0.5rem 0;
          }
          .cinza {
            background-color: ${theme.colors.elements};
            font-weight: normal;
            color: ${theme.colors.tertiary};
          }
        }
      }

      .btn-adicionar-remover {
        flex-wrap: wrap;
        gap: 1rem;
        .container-half {
          width: auto;
          min-width: auto;
          flex: 1;
        }

        @media (max-width: 480px) {
          .container-half {
            width: 100%;
            flex: unset;
          }
        }
      }
    }

    .produtos {
      width: 100%;
      max-width: 100%;
      max-height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(32rem, 1fr));
      gap: 4rem;
      align-items: stretch;
      align-content: start;
      justify-content: space-between;
      justify-items: center;

      @media (max-width: 680px) {
        grid-template-columns: repeat(auto-fill, minmax(19rem, 1fr));
        gap: 2.5rem;
      }

      @media (max-width: 420px) {
        grid-template-columns: 1fr;
        gap: 2rem;
      }

      .mensagem {
        padding-top: 10rem;
        width: 100%;
        grid-column: 1 / -1;
        grid-row: 1;
        align-self: flex-start;

        .texto-titulo {
          color: ${theme.colors.tertiary};
        }

        .texto-subtitulo {
          color: ${theme.colors.tertiary};
        }
      }

      .produtos-wrapper {
        display: contents;
      }

      .produto-container {
        width: 100%;
        max-width: 100%;
        height: 100%;
        align-self: stretch;
        cursor: pointer;
        transition: opacity 0.2s;

        &.em-outra-promocao {
          opacity: 0.4;
          pointer-events: none;
        }

        a {
          width: 100%;
          height: 100%;
        }

        .button-wrapper {
          height: 100%;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          white-space: nowrap;
          flex-grow: 1;
          padding: 1rem 0;

          .seletor-variacoes {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 1.5rem;
            width: 100%;
            margin-bottom: 1rem;
            padding: 0.5rem 0;
            overflow: hidden;
            cursor: pointer;
            color: ${(props) => props.theme.colors.tertiary};

            input[type="checkbox"] {
              flex-shrink: 0;
              pointer-events: none;
            }

            .texto {
              min-width: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          .botao-remover {
            background-color: ${theme.colors.elements};
            color: ${theme.colors.tertiary};
            padding: 0.5rem !important;
            width: 100% !important;

            &::after {
              content: "Remover promoção";
              display: block;
            }

            @media (max-width: 680px) {
              &::after {
                content: "Remover";
              }
            }
          }

          .botao-adicionar {
            padding: 0.5rem !important;
            width: 100% !important;

            &::after {
              content: "Aplicar promoção";
              display: block;
            }

            @media (max-width: 680px) {
              &::after {
                content: "Aplicar";
              }
            }
          }

          .botao-disabled {
            background-color: ${theme.colors.elements};
            color: ${theme.colors.placeholder};
            padding: 0.5rem !important;
            width: 100% !important;
            cursor: not-allowed;

            &::after {
              content: "Outra promoção";
              display: block;
            }

            @media (max-width: 680px) {
              &::after {
                content: "Em outra";
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 1024px) {
    padding: 0 0 5rem 0;
    .produtos-wrapper {
      height: 100vh;
    }
  }

  @media (max-width: 320px) {
    .grid-header {
      column-gap: 1rem;
      row-gap: 0.5rem;

      .half-width {
        width: 100%;
      }
    }

    .produtos-wrapper {
      .informacoes {
        .btn-adicionar-remover {
          gap: 0.5rem;
        }
      }

      .produtos {
        gap: 1.5rem;
      }
    }
  }
`;

export default ProdutosPromocaoContainer;
